var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('b-alert', {
    staticClass: "mb-2",
    attrs: {
      "show": "",
      "variant": "primary"
    }
  }, [_c('strong', [_vm._v("Cara penempatan:")]), _vm._v(" (1) Pilih no. invoice penerimaan → (2) Klik baris barang di kiri → (3) Isi gudang, lokasi, dan jumlah → (4) Klik "), _c('em', [_vm._v("Tambah ke antrian")]), _vm._v(" (bisa berulang untuk barang lain) → (5) Klik "), _c('em', [_vm._v("Simpan penempatan")]), _vm._v(". ")]), _vm.hasSharedBarang ? _c('b-alert', {
    staticClass: "mb-2",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Beberapa baris di invoice ini memakai "), _c('strong', [_vm._v("barang yang sama")]), _vm._v(". Sisa dihitung per barang (bukan per baris detail), jadi penempatan satu baris akan mengurangi sisa semua baris dengan barang tersebut. ")]) : _vm._e(), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [!_vm.isInvoiceAvailable ? _c('b-form-group', {
    attrs: {
      "label": "Pilih No. Invoice"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function reduce(option) {
        return option.value;
      },
      "options": _vm.invoiceList,
      "label": "text",
      "placeholder": "Cari / pilih invoice..."
    },
    model: {
      value: _vm.selectedInvoice,
      callback: function callback($$v) {
        _vm.selectedInvoice = $$v;
      },
      expression: "selectedInvoice"
    }
  })], 1) : _c('div', [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Penerimaan")]), _c('strong', [_vm._v("ID " + _vm._s(_vm.pb.id) + " — No. Invoice: " + _vm._s(_vm.pb.no_invoice))])])], 1), _c('b-col', {
    staticClass: "d-flex align-items-end justify-content-md-end",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Tambah lokasi penyimpanan kosong',
      expression: "'Tambah lokasi penyimpanan kosong'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "mt-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$router.push("/penyimpanan/add");
      }
    }
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Penyimpanan Barang ")], 1)])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Barang dari penerimaan")]), _c('p', {
    staticClass: "text-muted small mb-2"
  }, [_vm._v(" Klik baris untuk memilih barang yang akan ditempatkan. ")]), !_vm.form.penerimaan_id ? _c('div', {
    staticClass: "text-center text-muted py-4"
  }, [_vm._v(" Pilih no. invoice terlebih dahulu. ")]) : !_vm.barangs.length ? _c('div', {
    staticClass: "text-center text-muted py-4"
  }, [_vm._v(" Tidak ada barang pada penerimaan ini. ")]) : _c('div', {
    staticClass: "barang-pick-list"
  }, _vm._l(_vm.barangs, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "barang-pick-item",
      class: {
        'is-selected': _vm.isBarangSelected(item)
      },
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function click($event) {
          return _vm.selectBarang(item);
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.selectBarang(item);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-start justify-content-between"
    }, [_c('div', {
      staticClass: "pr-1"
    }, [_c('div', {
      staticClass: "barang-pick-name"
    }, [_vm._v(" " + _vm._s(item.barang ? item.barang.nama : "-") + " "), _vm.isSharedBarang(item) ? _c('b-badge', {
      staticClass: "ml-50",
      attrs: {
        "variant": "warning"
      }
    }, [_vm._v(" sama ")]) : _vm._e()], 1), _c('div', {
      staticClass: "barang-pick-sisa",
      class: {
        'is-empty': _vm.effectiveSisa(item) <= 0
      }
    }, [_vm._v(" Sisa: " + _vm._s(_vm.effectiveSisa(item)) + " " + _vm._s(item.barang && item.barang.satuan ? item.barang.satuan.satuan : "") + " ")])]), _vm.isBarangSelected(item) ? _c('feather-icon', {
      staticClass: "barang-pick-check flex-shrink-0",
      attrs: {
        "icon": "CheckCircleIcon",
        "size": "22"
      }
    }) : _vm._e()], 1)]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Form penempatan")]), _c('p', {
    staticClass: "text-muted small mb-2"
  }, [_vm.selectedBarang && _vm.selectedBarang.barang ? [_vm._v(" Barang dipilih: "), _c('strong', [_vm._v(_vm._s(_vm.selectedBarang.barang.nama))]), _vm._v(" — sisa efektif "), _c('strong', [_vm._v(_vm._s(_vm.effectiveSisa(_vm.selectedBarang)))]), _vm._v(" " + _vm._s(_vm.selectedBarang.barang.satuan ? _vm.selectedBarang.barang.satuan.satuan : "") + " ")] : [_vm._v(" Pilih barang di tabel kiri sebelum mengisi lokasi & jumlah. ")]], 2), _c('fieldset', {
    attrs: {
      "disabled": !_vm.selectedBarang
    }
  }, [!_vm.isInvoiceAvailable ? _c('b-form-group', {
    attrs: {
      "hidden": ""
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "penerimaan",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Penerimaan")]), _c('v-select', {
          attrs: {
            "options": _vm.invoiceList,
            "required": !_vm.form.penerimaan_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text"
          },
          model: {
            value: _vm.form.penerimaan_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "penerimaan_id", $$v);
            },
            expression: "form.penerimaan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 669795941)
  })], 1) : _vm._e(), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "gudang",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Gudang "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('v-select', {
          attrs: {
            "options": _vm.gudangs,
            "required": !_vm.form.gudang_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "placeholder": "Pilih gudang"
          },
          model: {
            value: _vm.form.gudang_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "gudang_id", $$v);
            },
            expression: "form.gudang_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "blok",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Blok "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('v-select', {
          attrs: {
            "options": _vm.bloks,
            "required": !_vm.form.blok_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "placeholder": "Pilih blok"
          },
          model: {
            value: _vm.form.blok_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "blok_id", $$v);
            },
            expression: "form.blok_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Pallet "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(opsional)")])]), _c('v-select', {
    attrs: {
      "options": _vm.palets,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Opsional"
    },
    model: {
      value: _vm.form.palet_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "palet_id", $$v);
      },
      expression: "form.palet_id"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Rak "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(opsional)")])]), _c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.raks,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Opsional"
    },
    model: {
      value: _vm.form.rak_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rak_id", $$v);
      },
      expression: "form.rak_id"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Laci "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(opsional)")])]), _c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.lacis,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Opsional"
    },
    model: {
      value: _vm.form.laci_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "laci_id", $$v);
      },
      expression: "form.laci_id"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jumlah input",
      "label-for": "nilai",
      "description": "Qty sebelum dikalikan konversi satuan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nilai",
      "type": "number",
      "min": "0",
      "placeholder": "0"
    },
    model: {
      value: _vm.nilai,
      callback: function callback($$v) {
        _vm.nilai = $$v;
      },
      expression: "nilai"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Konversi satuan",
      "label-for": "konversi",
      "description": "Default pcs / satuan dasar"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "konversi",
      "options": _vm.optkonversi,
      "placeholder": "konversi"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": 1
          }
        }, [_vm._v(" pcs (×1) ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.id_satuan,
      callback: function callback($$v) {
        _vm.id_satuan = $$v;
      },
      expression: "id_satuan"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jumlah hasil",
      "label-for": "jumlah",
      "description": "Harus ≤ sisa efektif barang dipilih"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "jumlah",
      "type": "number",
      "min": "1",
      "placeholder": "Jumlah"
    },
    model: {
      value: _vm.form.jumlah,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "jumlah", $$v);
      },
      expression: "form.jumlah"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBarang($event);
      }
    }
  }, [_vm._v(" Tambah ke antrian ")])], 1)], 1)])], 1), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Antrian penempatan")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.addedItems.length) + " item siap disimpan ")])]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.addedItems.length
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" Simpan penempatan ")])], 1), !_vm.addedItems.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada barang di antrian. Isi form lalu klik "), _c('strong', [_vm._v("Tambah ke antrian")]), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "fields": _vm.fieldsAddedItems,
      "bordered": "",
      "striped": "",
      "responsive": "",
      "items": _vm.addedItems
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
      }
    }, {
      key: "cell(lokasi)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('strong', [_vm._v(_vm._s(item.lokasi))])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(row) {
        return [_c('b-link', {
          staticClass: "text-danger",
          attrs: {
            "title": "Hapus dari antrian"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.removeQueuedItem(row.index);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "24",
            "icon": "XCircleIcon"
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }